import React, { useState, useEffect } from 'react';
import { Menu, ClickAwayListener, MenuItem, ListItemIcon, ListItemText, Divider } from '@material-ui/core';
import EditIcon from '@material-ui/icons/Edit';
import LinkOutlinedIcon from '@material-ui/icons/LinkOutlined';
import ArrowRightAltOutlinedIcon from '@material-ui/icons/ArrowRightAltOutlined';
import AddBoxIcon from '@material-ui/icons/AddBox';
import DeleteIcon from '@material-ui/icons/Delete';
import { useDispatch } from 'react-redux';

import { SheetKinds, setDefaultSheet } from '../redux/sheetDbSlice'
import { ArrowMenuAction, ArrowMenuData, WorkAreaStateType } from './BookEditor';

type ArrowMenuProps = {
  onClose: () => void;
  data: ArrowMenuData;
  removeSelect: () => void;
  arrowMenuClicked: ArrowMenuAction;
  closeBlankMenu: () => void;
  nodeClicked: (workArea: WorkAreaStateType, id?: string) => void;
  sheetKind: SheetKinds;
}
const ArrowMenu: React.FC<ArrowMenuProps> = ({ onClose, data, removeSelect, arrowMenuClicked, closeBlankMenu, nodeClicked, sheetKind }) => {
  const dispatch = useDispatch();
  const [enable, setEnable] = useState(false);
  const [jumpDisabled, setJumpDisabled] = useState(true);
  type HandlingKey = 'edit' | 'link' | 'jump' | 'cutIn' | 'delete'

  useEffect(() => {
    if (!data) return;
    closeBlankMenu();
    if (data.arrow.links && data.arrow.links.length > 0) setJumpDisabled(false);
    else setJumpDisabled(true);
  }, [data])

  const allClose = () => {
    onClose();
    removeSelect();
  }
  const onJump = (id: string) => {
    arrowMenuClicked.jump(id);
  }
  const handlingExe = (key: HandlingKey) => {
    if (!data) return;
    switch (key) {
      case 'edit': arrowMenuClicked.edit(data.id); break;
      case 'link': arrowMenuClicked.link(data.id); break;
      case 'jump': onJump(data.id); break;
      case 'cutIn': arrowMenuClicked.cutIn(data.id); break;
      case 'delete': arrowMenuClicked.delete(data.id); break;
    }
    onClose();
  }

  return (
    <Menu open={Boolean(data)} onClose={allClose}
      style={{zIndex: 998, pointerEvents: enable ? 'auto' : 'none'}}
      elevation={4}
      anchorReference="anchorPosition"
      anchorPosition={data ? { top: data.y, left: data.x } : undefined}
    >
      <ClickAwayListener onClickAway={allClose}>
        <div style={{pointerEvents: 'all'}}
          onMouseOver={() => setEnable(true)}
          onMouseLeave={() => setEnable(false)}
        >
          <MenuItem onClick={() => handlingExe('edit')}>
            <ListItemIcon><EditIcon fontSize="small" /></ListItemIcon>
            <ListItemText>矢印を編集する</ListItemText>
          </MenuItem>
          <Divider />
          <MenuItem onClick={() => handlingExe('link')}>
            <ListItemIcon><LinkOutlinedIcon fontSize="small" /></ListItemIcon>
            <ListItemText>リンクを設定する</ListItemText>
          </MenuItem>
          <MenuItem onClick={() => handlingExe('jump')} disabled={jumpDisabled}>
            <ListItemIcon><ArrowRightAltOutlinedIcon fontSize="small" /></ListItemIcon>
            <ListItemText>リンク先にジャンプする</ListItemText>
          </MenuItem>
          <Divider />
          { sheetKind === 'map' &&
          <>
            <MenuItem onClick={() => handlingExe('cutIn')}>
              <ListItemIcon><AddBoxIcon fontSize="small" /></ListItemIcon>
              <ListItemText>カードカットインをする</ListItemText>
            </MenuItem>
            <Divider />
          </>
          }
          <MenuItem onClick={() => handlingExe('delete')}>
            <ListItemIcon><DeleteIcon fontSize="small" /></ListItemIcon>
            <ListItemText>この矢印を削除する</ListItemText>
          </MenuItem>
        </div>
      </ClickAwayListener>
    </Menu>
  );
}

export default ArrowMenu;
